/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Validation constraints for a reading or setting value.
 */
export type Validations = {
  /**
   * List of allowed values.
   */
  enum?: Array<string> | undefined;
  /**
   * Maximum length for string/enum values.
   */
  maxLength?: number | undefined;
  /**
   * Maximum allowed numeric value.
   */
  maxValue?: number | undefined;
  /**
   * Minimum length for string/enum values.
   */
  minLength?: number | undefined;
  /**
   * Minimum allowed numeric value.
   */
  minValue?: number | undefined;
  /**
   * Regular expression pattern to match the value.
   */
  pattern?: string | undefined;
};

/** @internal */
export const Validations$inboundSchema: z.ZodType<
  Validations,
  z.ZodTypeDef,
  unknown
> = z.object({
  enum: types.optional(z.array(types.string())),
  max_length: types.optional(types.number()),
  max_value: types.optional(types.number()),
  min_length: types.optional(types.number()),
  min_value: types.optional(types.number()),
  pattern: types.optional(types.string()),
}).transform((v) => {
  return remap$(v, {
    "max_length": "maxLength",
    "max_value": "maxValue",
    "min_length": "minLength",
    "min_value": "minValue",
  });
});
/** @internal */
export type Validations$Outbound = {
  enum?: Array<string> | undefined;
  max_length?: number | undefined;
  max_value?: number | undefined;
  min_length?: number | undefined;
  min_value?: number | undefined;
  pattern?: string | undefined;
};

/** @internal */
export const Validations$outboundSchema: z.ZodType<
  Validations$Outbound,
  z.ZodTypeDef,
  Validations
> = z.object({
  enum: z.array(z.string()).optional(),
  maxLength: z.number().int().optional(),
  maxValue: z.number().optional(),
  minLength: z.number().int().optional(),
  minValue: z.number().optional(),
  pattern: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    maxLength: "max_length",
    maxValue: "max_value",
    minLength: "min_length",
    minValue: "min_value",
  });
});

export function validationsToJSON(validations: Validations): string {
  return JSON.stringify(Validations$outboundSchema.parse(validations));
}
export function validationsFromJSON(
  jsonString: string,
): SafeParseResult<Validations, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Validations$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Validations' from JSON`,
  );
}
